<template>
  <DatePicker
    :value="modelValue"
    :type="type"
    :range="range"
    :format="format"
    :disabled-date="disabledDate"
    :clearable="clearable"
    :disabled="disabled"
    @update:value="$emit('update:modelValue', $event)"
  />
</template>

<script lang="ts" setup>
import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'

defineProps({
  type: {
    type: String,
    default: undefined,
  },
  range: {
    type: Boolean,
    default: undefined,
  },
  modelValue: {
    type: [Object, Date],
    default: undefined,
  },
  format: {
    type: String,
    default: undefined,
  },
  disabledDate: {
    type: Function,
    default: undefined,
  },
  clearable: {
    type: Boolean,
    default: undefined,
  },
  disabled: {
    type: Boolean,
    default: undefined,
  },
})

defineEmits(['update:modelValue'])
</script>

<style lang="stylus" scoped>
:deep(.mx-input)
  height: 2.375rem !important
  @apply shadow-sm rounded-md border-gray-300 hover_border-gray-300 text-gray-700 focus_outline-none focus_ring-2 ring-gray-900

  &:focus
    @apply border-gray-300

:deep(.mx-table)
  @apply font-inter
</style>
